import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import ImageLoad from 'components/ImageLoad';
import Day from 'dayjs';
import style from './style.scss'; //NOSONAR
import TagManagerService from 'services/TagManager';

const BoxBannersSmall = (props) => {
    const { banner } = props;

    const formatDate = (date) => {
        if(!date) return '';
        const dates = new Date(date);
        const dateString = ('0' + dates.getDate()).slice(-2) + '/'
        + ('0' + (dates.getMonth() + 1)).slice(-2) + '/'
        + dates.getFullYear();
        return dateString
    }


    const promotionClick = (event) => {

        const obj = {
            url_banner: event.url,
            id: event.image ? event.image.split('/').pop() : '',
            title: event.title,
            creative: event.typePromotion,
            position: props.position

        }
        TagManagerService.promotionsClick(obj);
    }

    const startDate = formatDate(Day(banner.start_date.replace(/\s/, 'T')).format());
    const endDate = formatDate(Day(banner.end_date.replace(/\s/, 'T')).format());
    let bannerAlt = banner ? banner.title : banner.image;



    return (
        <div className='banner-box-small' onClick={()=>promotionClick(banner)}>
            <Link to={banner.url} {...((banner.url_target != '_self')  && { target: banner.url_target })}  rel="noopener noreferrer" className="banner-image-link" >
                <ImageLoad src={banner.image} className='banner-box-small-image' alt={bannerAlt} />
            </Link>
            {banner.title &&
                <Link to={banner.url} {...((banner.url_target != '_self')  && { target: banner.url_target })} rel="noopener noreferrer" className="banner-box-small-title">
                    {banner.title}
                </Link>
            }
            {banner.start_date && <Link to={banner.url} {...((banner.url_target != '_self')  && { target: banner.url_target })} rel="noopener noreferrer" className="banner-box-small-date">
                {startDate} {endDate ? 'al ' +endDate : ''}
            </Link>}

            <Link to={banner.url} {...((banner.url_target != '_self')  && { target: banner.url_target })} rel="noopener noreferrer" className="banner-box-small-link">
                Ver más
            </Link>
        </div>
    )
}

BoxBannersSmall.propTypes = {
    banner: PropTypes.object,
    position: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
}

export default BoxBannersSmall;
